import { makeStyles } from '@material-ui/core/styles';
import { isiOS } from '../../../utils/utility';
import { fontClasses } from '../../../fontStyles';

const makeStyle = makeStyles((theme) => ({
    siteSetupContainer: {
        overflowY: "auto",
        overflowX: "hidden",
        width: "100% !important",
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: ' column',
        backgroundColor: `${theme.palette.primary.background}`,
        padding: '28px 20px 24px',
        marginTop: isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
        justifyContent: "space-between",
        height: isiOS() ? 'calc(100vh - 64px - env(safe-area-inset-top))' : 'calc(100vh - 64px)',
    },
        numberedList: {
            ...fontClasses.body1,
            color: `${theme.palette.tertiary.headingText}`,
            paddingLeft: '24px',
            margin: '8px auto 0 auto',
            listStyleType: 'decimal',
            listStylePosition: 'outside',
            '& li': {
                marginTop: '8px',
                display: 'list-item',
                listStyleType: 'auto !important',
            },      
        },
        numberedListNone:{
           '& li': {
                listStyleType: 'none !important',
            }, 
        },
    siteSetupContainerNewUser: {
        overflowY: "auto",
        overflowX: "hidden",
        width: "100% !important",
        display: 'flex',
        flex: 'none !important',
        flexDirection: ' column',
        backgroundColor: `${theme.palette.primary.background}`,
        padding: '28px 20px 24px',
        marginTop: isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
        justifyContent: "space-between",
        height: isiOS() ? 'calc(100vh - 130px - env(safe-area-inset-top))' : 'calc(100vh - 130px)',
    },
    siteSetupDetails: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
        color: `${theme.palette.tertiary.titleBox}`,
    },
    siteSetupHeader: {
        ...fontClasses.title2,
        textAlign: 'left',
        color: `${theme.palette.tertiary.headingText} !important`,
    },
    customCircularLoader: {
        color: '#01B5DE !important'
    },
    siteSetupSubheading: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText}`,
        marginTop: '8px' ,
    },
    instructionFormate: {
        ...fontClasses.body1,
        paddingLeft: "16px",
        margin: "0px",
        '& li': {
            listStyleType: "decimal !important",
            marginTop: "12px"
        }
    },
    siteSetupSettings: {
        ...fontClasses.body2,
        fontSize: '14px !important',
        marginTop: '20px',
        color: `${theme.palette.tertiary.headingText}`,
    },
    siteSetupSubHeader: {
        ...fontClasses.body1,
        marginTop: '12px',
        color: `${theme.palette.tertiary.headingText} !important`,
    },
    cameraPermissionBox: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 0",
        width: "100%",
        marginTop: '10px',
    },
    cameraPermission: {
        ...fontClasses.body1,
        fontSize: '14px !important',
        color: `${theme.palette.tertiary.headingText} !important`,
    },
    icon: {
        marginTop: '10px',
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        marginTop: '16px',
    },
    permissionButton: {
        color: `${theme.palette.tertiary.provisionEnableButton}`,
        display: 'flex',
        justifyContent: 'center',
        textTransform: "uppercase",
        alignItems: 'center',
        borderRadius: '8px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
        backgroundColor: `${theme.palette.primary.background}`,
        padding: '6px 8px 4px 8px',
        ...fontClasses.body1,
        fontWeight: '700',
        letterSpacing: '0.24px',
        '&.Mui-disabled': {
            backgroundColor: 'transparent !important',
            borderColor: '#01B5DE !important'
        }
    },

    continueButton: {
        background: `${theme.palette.tertiary.provisionEnableButton}`,
        color: '#fff !important',
        textAlign: 'center',
        width: '100%',
        padding: '12px',
        textTransform: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        '&.Mui-disabled': {
            backgroundColor: `${theme.palette.tertiary.disableApplyButtonBg} !important`,
            borderColor: `${theme.palette.tertiary.disableApplyButtonBg} !important`,
            '& span': {
                color: `${theme.palette.tertiary.disableApplyButtonText} !important`,
            }
        }
    },
    tnc: {
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
        "& .MuiButtonBase-root": {
            padding: '0px 4px 0px 0px',
        },
        "& input": {
            position: "absolute",
            top: "12px",
            left: "12px"
        },
        "& .MuiSvgIcon-root": {
            fill: theme.palette.primary.text,
        },
        "& .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root": {
            fill: "#01B5DE !important",
        },
    },

    tncDescription: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.provisiningSubHeading} !important`,
    },
    infoIconContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        alignItems: 'center',
        "& p": {
            color: `${theme.palette.primary.heading} !important`,
        },
        "& span": {
            marginTop: '4px'
        }
    },

    permissionTextBox: {
        display: "flex",
        alignItems: "center",
        gap: "4px",
    },
    captureButton: {
        color: `${theme.palette.tertiary.provisionEnableButton}`,
        display: 'flex',
        justifyContent: 'center',
        textTransform: "none",
        alignItems: 'center',
        borderRadius: '8px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
        backgroundColor: `${theme.palette.primary.background}`,
        padding: '10px 16px',
        width: '100%',
        marginTop: '16px',
        ...fontClasses.body1,
        fontWeight: '700',
        '&.Mui-disabled': {
            backgroundColor: 'transparent !important',
            borderColor: `${theme.palette.tertiary.disableApplyButtonBg} !important`,
            '& span': {
                color: `${theme.palette.tertiary.disableApplyButtonText} !important`,
            }
        }
    },
    capturedImageContainer: {
        width: '100%',
        height: '220px',
        marginTop: '16px',
        borderRadius: '8px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
    },
    capturedImage: {
        width: '100%',
        height: '220px',
        objectFit: 'cover',
        display: 'block',
    },
}))

export { makeStyle }